
  import { Vue, Component, Prop } from "vue-property-decorator";

  interface ContractorUser {
    contracts: Contract[];
    [key: string]: any;
  }

  interface Contract {
    id: string;
    deleted?: boolean;
    managers: Manager[];
  }

  interface Manager {
    id: string;
    approved: boolean;
  }

  @Component
  export default class ContractorManagerInformationProvider extends Vue {
    @Prop({ type: Object, required: true }) readonly user!: ContractorUser;
    @Prop({ type: String, default: undefined }) readonly localId?: string | null;

    requestSent: boolean | null = null;

    get contractorId(): string | undefined {
      return this.user?.contracts[0]?.id;
    }

    get isRequestContractorShown(): boolean {
      return !this.isAccessGranted && !this.isContractorRequested;
    }

    get isCompanyMember(): boolean {
      return this.user?.contracts.length > 0;
    }

    get contract(): Contract | undefined {
      return this.user?.contracts[0];
    }

    get managerContractor(): Manager | undefined {
      const managers = this.contract?.managers;

      if (!managers || managers.length === 0) {
        return undefined;
      }

      return managers[0];
    }

    get isAccessGranted(): boolean {
      if (!this.isCompanyMember) {
        return false;
      }

      return Boolean(!this.contract?.deleted && this.managerContractor?.approved);
    }

    get isContractorRequested(): boolean {
      if (this.requestSent !== null) {
        return this.requestSent;
      }

      if (!this.isCompanyMember) {
        return false;
      }
      return this.managerContractor?.approved === false;
    }

    changeRequestStatus(status: boolean): void {
      this.requestSent = status;
    }
  }
